<template>
     <div class="container">
        <b-card bg-variant="light" class="my-1">
            <div class="row">
                <div class="col-12">
                    <h2>Formulario de contacto</h2>
                    <div class="row">
                        <div class="col col-lg-6">
                            <b-form @submit.prevent="submit">
                                <b-form-input v-model="reg.nom" required placeholder="Nombre"></b-form-input><br>
                                <b-form-input v-model="reg.ema" required placeholder="Email"></b-form-input><br>
                                <b-form-input v-model="reg.tfn" placeholder="Teléfono (Opcional)"></b-form-input><br>
                                <b-form-textarea v-model="reg.txt" rows=4 required placeholder="Mensaje"/><br>

                                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0">
                                    Acepta
                                    <router-link to="/politica" class="pl-1">Política de Privacidad</router-link>
                                </b-form-checkbox>
                                <b-form-invalid-feedback :state="!chk_selected">
                                    <b-alert variant="danger" show>Debes Aceptar Politica de Privacidad</b-alert>
                                </b-form-invalid-feedback>
                                <!-- ASPM -->
                                 <b-form-input style="display:none;" v-model="reg.aspm" placeholder="No"></b-form-input>
                                <br>
                                <!-- <b-button block variant="success" @click="enviar">ENVIAR</b-button> -->
                                <b-btn type="submit" size="sm" variant="primary" >ENVIAR</b-btn>
                            </b-form>
                        </div>


                        <div class="col-12 col-lg-5 ml-auto">
                            <div class="contact-info">
                                <p>
                                    <span class="h6">
                                        Para más información, envíanos tu consulta y resolveremos todas tus dudas.
                                    </span>
                                </p>
                                <hr/>
                                <div class="mr-2">
                                    <h6>Teléfono</h6>
                                    <div class="font-weight-bold">
                                        <b-icon-telephone-fill />
                                        {{ aplica.empresa.telefono }}
                                    </div>
                                </div>
                                <hr/>
                                <div class="mr-2">
                                    <h6>Email</h6>
                                    <div class="font-weight-bold">
                                        <b-icon-envelope-fill/>
                                        {{ aplica.empresa.email }}
                                    </div>
                                </div>
                                <hr/>
                                <div class="mr-2 d-inline">
                                    <h6>Dirección</h6>
                                    <b-icon-map/>
                                    <div class="d-table-cell pl-2 font-weight-bold ">
                                        {{ aplica.empresa.direccion }} <br>
                                        {{ aplica.empresa.poblacion }}
                                    </div>
                                </div>
                                <hr/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
        <!-- <publicidad txt="Ofertas de ¡¡ <b>ultima hora</b> !!"/>  -->

        <!-- <b-btn @click="showModal('Hoteles')">Hoteles</b-btn> &nbsp;
        <b-btn @click="showModal('Registro')">Registro</b-btn> &nbsp;
        <b-btn @click="showModal('Login')">Login</b-btn>         -->

    </div>
</template>

<script>
//import publicidad from '@/components/publicidad.vue';

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'contacto',
    components: {
        //publicidad,
    },
    data() {
        return {
            submitted: false,
            message: 'Error',
            reg: {
                pro: 5,
                nom: '',
                ema: '',
                tfn: '',
                txt: '',
                chk: false,
            },
        };
    },
    computed: {
        ...mapState(['aplica','errores']),

        chk_selected() {
            return this.submitted && !this.reg.chk;
        }
    },
    methods: {
        ...mapMutations(['modal']),
        ...mapActions(['exec']),

        submit(evt) {
            evt.preventDefault();

            //controlar errores
            this.submitted=true;
            if (!this.reg.chk) return;

            //enviar
            this.enviar();
        },
        async enviar() {
            //this.loading();
            //let r=await this.$store.dispatch('exec', 'contacto', this.reg);
            let r=await this.exec({api:'contacto', arg:this.reg});

            let msg=r.error ? r.datos : 'Su Consulta ha sido enviada ...';
            //this.$store.commit('modal','Formulario Contacto',msg);
            this.modal({tit:"Formulario Contacto", msg:msg});

            this.submitted=false;
            this.reg={pro:5, nom:'',ema: '',tfn: '',txt: '',chk: false};
            //this.loading(false);
            this.$router.push('/reserva');
        },

    }
}
</script>
